import { createContext, useEffect, useState } from "react";
import { GetProjectsDetails } from "../Services/firebase";

const GlobalContext = createContext(null);

const GlobalProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const fetchProjectsData = async () => {
    const results = GetProjectsDetails();
    results
      .then((pro) => {
        setProjects(pro);
      })
      .catch((err) => {
        console.log("error:", err);
      });
  };

  useEffect(() => {
    fetchProjectsData();
  }, []);

  return (
    <GlobalContext.Provider value={{ projects }}>
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalProvider };
